import { module } from 'angular';
import { CORE_UTILS_MODULE } from 'src/modules/core/utils/CoreUtilsModule';
import { CORE_FILTERS_MODULE } from 'src/modules/core/filters/CoreFilterModule';

export const CORE_MODULE = module('coreModule', [
    CORE_UTILS_MODULE.name,
    CORE_FILTERS_MODULE.name,
]);
